var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrendingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 12,
    viewBox: "0 0 26 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3137 1.045C23.3337 0.0649976 21.7537 0.0649976 20.7737 1.045C20.0537 1.765 19.8637 2.825 20.2137 3.725L17.0837 6.855C16.4937 6.625 15.8437 6.625 15.2637 6.855L12.1337 3.725C12.4837 2.825 12.3037 1.775 11.5737 1.045C10.5937 0.0649976 9.01373 0.0649976 8.03373 1.045C7.32373 1.775 7.14373 2.825 7.49373 3.725L4.36373 6.855C3.46373 6.505 2.41373 6.685 1.68373 7.415C0.70373 8.395 0.70373 9.975 1.68373 10.955C2.66373 11.935 4.24373 11.935 5.22373 10.955C5.94373 10.235 6.13373 9.175 5.78373 8.275L8.91373 5.145C9.50373 5.375 10.1537 5.375 10.7337 5.145L13.8637 8.275C13.5137 9.175 13.6937 10.225 14.4237 10.955C15.4037 11.935 16.9837 11.935 17.9637 10.955C18.6837 10.235 18.8737 9.175 18.5237 8.275L21.6537 5.145C22.5537 5.495 23.6037 5.315 24.3337 4.585C25.2937 3.605 25.2937 2.025 24.3137 1.045Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingIcon);
export default __webpack_public_path__ + "static/media/trendingIcon.26bc2123d37ad887afd8fe0e2001357f.svg";
export { ForwardRef as ReactComponent };